const Checkbox = ({ label, style, value, name, checked, onChange, reference }) => {
  return <div className={`checkbox${label ? '' : ' fitted'}`} style={style} onClick={e => e.stopPropagation()}>
    <input type="checkbox" name={name} value={value} id={`${name}_${value}`} checked={checked} onChange={onChange} ref={reference}/>
    <label htmlFor={`${name}_${value}`}>{label}</label>
  </div>
}

export default Checkbox
